var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 14,
    viewBox: "0 0 9 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.22421 7C8.22421 7.16741 8.19282 7.32981 8.13004 7.48717C8.06726 7.64454 7.98356 7.77513 7.87892 7.87892L2.10314 13.6547C1.87294 13.8849 1.57997 14 1.22421 14C0.86846 14 0.575485 13.8849 0.345291 13.6547C0.115097 13.4245 0 13.1315 0 12.7758C0 12.42 0.115097 12.1271 0.345291 11.8969L5.24215 7L0.345291 2.10314C0.115097 1.87295 0 1.57997 0 1.22422C0 0.868461 0.115097 0.575487 0.345291 0.345293C0.575485 0.115099 0.86846 0 1.22421 0C1.57997 0 1.87294 0.115099 2.10314 0.345293L7.87892 6.12108C8.00448 6.24664 8.09363 6.38266 8.14637 6.52915C8.1991 6.67564 8.22505 6.83259 8.22421 7Z",
    fill: "black",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrow);
export default __webpack_public_path__ + "static/media/right_arrow.c798b69d33a6b3e1438083be688fb620.svg";
export { ForwardRef as ReactComponent };